import React from 'react';
import { withAuthorization } from '../Session';

import GCList from './gc-list';

class NonAmazoneGiftCards extends React.Component {
    _isMounted = false;
    state = {};

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {}

    render() {
        return <GCList MasterGiftCard="QwikCilverNonAmazon" />;
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(NonAmazoneGiftCards);
